// extracted by mini-css-extract-plugin
export default {"root":"SectionSimpleDescription_root__lS-Lx","description":"SectionSimpleDescription_description__g32Iq"};